export const ArrowDownDate = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.52876 5.54933C3.78911 5.28898 4.21122 5.28898 4.47157 5.54933L8.00016 9.07792L11.5288 5.54933C11.7891 5.28898 12.2112 5.28898 12.4716 5.54933C12.7319 5.80968 12.7319 6.23179 12.4716 6.49214L8.54228 10.4214C8.24288 10.7208 7.75745 10.7208 7.45805 10.4214L3.52876 6.49214C3.26841 6.23179 3.26841 5.80968 3.52876 5.54933Z"
        fill="currentColor"
      />
    </svg>
  )
}
